import { DebitCardTransactionTypeV2 } from 'types/gql-global-types'

const DOWNLOADABLE_SUMMARY_TYPES = [
  DebitCardTransactionTypeV2.DE_OUT,
  DebitCardTransactionTypeV2.PURCHASE,
  DebitCardTransactionTypeV2.PURCHASE_CNP,
  DebitCardTransactionTypeV2.REFUND,
  DebitCardTransactionTypeV2.REFUND_CNP,
]

export const getHasDownloadableSummary = (type: DebitCardTransactionTypeV2) =>
  DOWNLOADABLE_SUMMARY_TYPES.includes(type)
